import type { ReactNode } from 'react';
import { DropDownBox, DropDownBoxComponentSpacing, DropDownBoxLayoutStyle } from './DropDownBox';
import UsaStates, { IStateResult } from 'usa-states';

interface StateDropDownProps {
    id: string;
    value: string | undefined;
    label: string;
    helperText?: string;
    required?: boolean;
    placeholder?: string;
    width?: string;
    readOnly?: boolean;
    onChange: (value: string) => void;
    validator?: React.ReactNode;
    onValidationEvent?: (isValid: boolean) => void;
    showInfoIcon?: boolean;
    infoText?: ReactNode;
    componentSpacing: DropDownBoxComponentSpacing;
    /** Label above the dropdown (Vertical, default) or beside it (Horizontal). */
    layoutStyle?: DropDownBoxLayoutStyle;
    /** Width of the label column when layoutStyle is Horizontal. Defaults to 120px. */
    labelWidth?: string;
    /** Height of the dropdown box. Omit to keep DropDownBox's default (54px). */
    height?: string;
}

export const StateDropDown: React.FC<StateDropDownProps> = ({
    id,
    value,
    label,
    helperText,
    required = false,
    placeholder,
    width,
    readOnly = false,
    onChange,
    validator,
    onValidationEvent,
    showInfoIcon = false,
    infoText,
    componentSpacing = DropDownBoxComponentSpacing.StandardSpacing,
    layoutStyle,
    labelWidth,
    height,
}) => {
    const usaStates: IStateResult[] = new UsaStates.UsaStates().states;

    return (
        <DropDownBox
            id={id}
            value={value}
            onChange={onChange}
            label={label}
            helperText={helperText}
            required={required}
            dataSource={usaStates}
            placeholder={placeholder}
            width={width}
            valueExpr='abbreviation'
            displayExpr={width && parseInt(width) <= 100 ? 'abbreviation' : 'name'}
            readOnly={readOnly}
            validator={validator}
            onValidationEvent={onValidationEvent}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
            componentSpacing={componentSpacing}
            layoutStyle={layoutStyle}
            labelWidth={labelWidth}
            height={height}
        />
    );
};
